import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { useResponseError } from '../../hooks/useResponseError';
import { InputText } from '../../elements/InputText';
import SelectControl from '../../elements/SelectControl';
import { useEffect, useState } from 'react';
import { getServiceAreas } from '../../services/userService';
import { STORAGE_USER } from '../../constants/storage';
import { ErrorBox } from '../../elements/ErrorBox';
import GooglePlacesAutocomplete from '../../elements/GooglePlacesAutocomplete';

export const PersonalInfo = ({ control, register, errors, userProfile, setValue }: any) => {
  const { responseError, setResponseError } = useResponseError();
  const [selectOptions, setSelectOptions] = useState();
  const { palette, typography } = useTheme();

  useEffect(() => {
    const getServiceAreasValues = async () => {
      try {
        const res = await getServiceAreas();

        const formatedItems = res.map((item: {
          id: string,
          name: string,
        }) => ({
          value: item.id,
          label: item.name
        }));

        setSelectOptions(formatedItems);
        // setValue('serviceAreaId', formatedItems[0].id);
      } catch (error: unknown) {
        setResponseError((error as Error)?.message || "Something went wrong");
      }
    };

    getServiceAreasValues();

    return () => { };
  }, []);

  const phoneField = register('phoneNumber');
  const firstNameField = register('firstName');
  const lastNameField = register('lastName');

  return (
    <Box sx={{
      width: '100%'
    }}>
      <Typography
        variant="h2"
        sx={{
          mb: '16px'
        }}
      >
        Personal information
      </Typography>
      <Box>
        <Box>
          <InputText
            inputProps={{ ...register('email') }}
            type='email'
            label='Email address'
            placeholder='Email address'
            error={!!errors['email']}
            helperText={errors['email'] ? errors['email'].message : ''}
            fullWidth
            disabled
            defaultValue={userProfile.email}
          />
        </Box>
        <Box>
          <InputText
            inputRef={phoneField.ref}
            inputProps={{ name: phoneField.name, onChange: phoneField.onChange, onBlur: phoneField.onBlur }}
            type='tel'
            label='Phone number'
            placeholder='10-digit phone number'
            error={!!errors['phoneNumber']}
            helperText={errors['phoneNumber'] ? errors['phoneNumber'].message : ''}
            fullWidth
          />
        </Box>
        <Box>
          <InputText
            inputRef={firstNameField.ref}
            inputProps={{ name: firstNameField.name, onChange: firstNameField.onChange, onBlur: firstNameField.onBlur }}
            type='text'
            label='First name'
            placeholder='First name'
            error={!!errors['firstName']}
            helperText={errors['firstName'] ? errors['firstName'].message : ''}
            fullWidth
          />
        </Box>
        <Box>
          <InputText
            inputRef={lastNameField.ref}
            inputProps={{ name: lastNameField.name, onChange: lastNameField.onChange, onBlur: lastNameField.onBlur }}
            type='text'
            label='Last name'
            placeholder='Last name'
            error={!!errors['lastName']}
            helperText={errors['lastName'] ? errors['lastName'].message : ''}
            fullWidth
          />
        </Box>
        {selectOptions && <Box sx={{
          position: 'relative',
        }}>
          <Controller
            control={control}
            name='serviceAreaId'
            render={({ field: { onChange, onBlur, value } }) => (
              <SelectControl
                label='Primary service area'
                items={selectOptions}
                onBlur={onBlur}
                onChange={onChange}
                value={value}
              />
            )}
          />
          <Box sx={{ mt: '8px' }}>
            <GooglePlacesAutocomplete
              handleChange={(data: any) => {
                setValue('serviceAddress', data?.description || '', { shouldDirty: true });
                setValue('serviceLatitude', data?.cordinates?.lat, { shouldDirty: true });
                setValue('serviceLongitude', data?.cordinates?.lng, { shouldDirty: true });
              }}
              label="Service address"
              placeholder="Start typing your address"
              noOptionsText="Enter your service address"
              initialAddress={userProfile?.client?.serviceAddress}
            />
            <input type="hidden" {...register('serviceAddress')} />
            <input type="hidden" {...register('serviceLatitude')} />
            <input type="hidden" {...register('serviceLongitude')} />
          </Box>
          {errors['serviceAreaId'] &&
            <ErrorBox
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {errors['serviceAreaId'].message}
            </ErrorBox>
          }
        </Box>}
      </Box>
    </Box>
  );
}